<template>
  <div class="md:flex">
    <!-- first -->
    <div class="m-2 md:w-3/12 w-4/12 flex">
      <img
        :src="imageUrl(data['poster_path'])"
        :alt="data['original_title']"
        class="w-full max-w-72 h-full md:h-72 xl:h-96"
      />
      <!-- actions -->
      <div class="block md:hidden">
        <actions
          v-bind="{
            externalIds: data.external_ids,
            homepage: data.homepage,
            videos: data.videos
          }"
        />
      </div>
    </div>
    <!-- middle content -->
    <div class="m-2 relative flex-1 flex xl:flex-nowrap flex-wrap">
      <div
        class="xl:border-0 md:border-l md:pl-2 border-gray-600 flex-1 flex-shrink-0"
      >
        <!-- actions -->
        <div class="hidden md:block">
          <actions
            v-bind="{
              externalIds: data.external_ids,
              homepage: data.homepage,
              videos: data.videos
            }"
          />
        </div>
        <p class="text-lg mt-4 mb-6 text-gray-500">
          {{ data["overview"] }}
        </p>
        <div v-if="data.credits">
          <div v-if="data.credits.crew.length">
            <div class="font-semibold text-lg mb-2 flex">
              <p class="mr-2">DIRECTOR:</p>
              <p class="text-gray-500">
                {{ data["credits"] ? crews(data["credits"]["crew"]) : null }}
              </p>
            </div>
          </div>
          <div v-if="data.credits.cast.length">
            <div class="font-semibold text-lg mb-2">
              <p class="mb-2">CASTS:</p>
              <casts :data="data.credits.cast" />
              <div class="text-center my-2">
                <router-link :to="`/movies/${data.id}/casts`">
                  <button-base>See more cast</button-base>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Last -->
      <div class="md:border-l md:pl-2 border-gray-600 lg:w-72 w-full">
        <div class="mb-4">
          <h5 class="font-semibold text-lg mb-2">DETAILS</h5>
          <!-- details -->
          <MoreInfo :data="data" />
        </div>
        <div v-if="data.reviews">
          <div v-if="data.reviews.results.length">
            <h5 class="font-semibold text-lg mb-2">REVIEWS</h5>
            <reviews :data="data.reviews.results" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- similar movies -->
  <div class="my-8" v-if="data.similar">
    <div v-if="data.similar.results.length">
      <h5 class="font-semibold text-lg mb-2">SIMILAR MOVIES</h5>
      <div class="my-2">
        <paper-swiper :datas="data.similar.results" />
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import Reviews from "./Partials/Reviews.vue";
import PaperSwiper from "@/components/PaperSwiper.vue";
import Actions from "./Partials/Actions.vue";
import MoreInfo from "./Partials/MoreInfo.vue";
import Casts from "./Partials/Casts.vue";
export default defineComponent({
  name: "movie",
  components: {
    Reviews,
    PaperSwiper,
    Actions,
    MoreInfo,
    Casts
  },
  props: ["data"],
  setup() {
    const crews = data => {
      const findName = data.find(i => {
        if (i.job === "Director") {
          return i;
        }
      });
      if (findName) {
        return findName.name;
      }
    };

    return { crews };
  }
});
</script>
